import React from 'react';
import AStotteValg from '../Utilities/A-StudiestotteValg';
import BSemesterValg from '../Utilities/B-SemestertypeValg';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import { Utbetalingsplan } from '../Models/Utbetalingsplan';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederHounDto from '../Models/VeilederHounDto';
import { connect } from 'react-redux';
import { VeilederHounAppState } from '../Store';
import { toggleUtbetalingsplan, toggleVilkar } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';
import { ResultatG } from '../Ids';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';

interface GResultOwnProps {
    idA?: string;
    idB?: string;
    verdiF?: number;
    resultat: number;
    utbetalingsplan: Utbetalingsplan;
}

type GResultatProps = MapStateToProps & MapDispatchToProps & GResultOwnProps;

class GResultatComponent extends React.PureComponent<GResultatProps> {
    utbetalingsplanRef = React.createRef<HTMLDivElement>();

    constructor(props: GResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onVisUtbetalingClicked = this.onVisUtbetalingClicked.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    componentDidMount(): void {
        updateLiveMessage();
    }

    onVisUtbetalingClicked(event: React.MouseEvent): void {
        this.props.toggleUtbetalingsplan();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    erHeltAr = (valgA: string | undefined, valgB: string | undefined): boolean => {
        return (
            valgA === AStotteValg.a1_heltAr || (valgA === AStotteValg.a3_deltid && valgB === BSemesterValg.b1_heltAr)
        );
    };

    harSkolepenger = (skolepengelan: number | undefined): boolean => {
        return (skolepengelan ? skolepengelan : 0) > 0;
    };

    render(): JSX.Element {
        const { idA, idB, verdiF, resultat, visUtbetalingsplan, visVilkar, epiContext } = this.props;
        const { locale, valuta } = this.props.epiContext;

        return (
            <div id={ResultatG} className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(
                                epiContext,
                                this.erHeltAr(idA, idB) ? 'tittelEttSkolear' : 'tittelEttSemester',
                            )}
                        </h3>
                    </div>
                    <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                        <div className="c-veileder__resultat-tekst">
                            <span>{tilPengerFormat(resultat, locale)}</span>
                            <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{valuta}</span>
                        </div>
                        <p className="c-veileder__tekst c-veileder__tekst--tett">
                            {contentResolver(epiContext, 'ytelserBasisstotte')}
                            {this.harSkolepenger(verdiF) ? contentResolver(epiContext, 'ytelserSkolepenger') : null}
                        </p>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--with-double-space-mobile">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'lenketekstVilkar')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'modalVilkarAriaLabel')}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalVilkarTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'modalVilkarContent', 2)}
                            />
                        </ModalCompontent>
                    </div>
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--footer c-veileder__content--indented">
                        <button
                            type="button"
                            className={`c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--icon-after c-knapp--pil-opp-hvit ${
                                visUtbetalingsplan ? 'c-knapp--icon-reversed' : ''
                            }`}
                            onClick={this.onVisUtbetalingClicked}
                        >
                            {contentResolver(epiContext, 'lenketekstUtbetalingsplan')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederHounDto>;
    visUtbetalingsplan: boolean;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleUtbetalingsplan: typeof toggleUtbetalingsplan;
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederHounAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visUtbetalingsplan: state.valg.visUtbetalingsplan,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleUtbetalingsplan, toggleVilkar, updateZIndex },
)(GResultatComponent);
